import { useMemo } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { Crumb } from './components/Breadcrumbs';
import { insightsHubCategoriesConfig } from './constants';

const RESEARCH_UPDATES = { label: 'Research team updates', to: '/research-hub/research-updates' };
const MARKET_UPDATES = { label: 'Calyx market updates', to: '/research-hub/market-updates' };

export default function useInsightsHubBreadcrumbs(title?: string): Crumb[] {
  const { pathname } = useLocation();
  const { category, slug } = useParams();

  return useMemo(() => {
    const path = pathname.replace(/\/+$/, '');
    const leaf = title ? [{ label: title }] : [];

    if (path === '/research-hub' || path === '') return [];
    if (path === '/research-hub/corsia') return [{ label: 'CORSIA' }];
    if (path === '/research-hub/research-updates') return [{ label: RESEARCH_UPDATES.label }];
    if (path === '/research-hub/market-updates') return [{ label: MARKET_UPDATES.label }];
    if (path.startsWith('/research-hub/research_update/')) return [RESEARCH_UPDATES, ...leaf];
    if (path.startsWith('/research-hub/market-update/')) return [MARKET_UPDATES, ...leaf];
    if (path.startsWith('/research-hub/pinned/')) return leaf;

    // The search results page has no breadcrumb in the design.
    if (path === '/research-hub/search') return [];

    if (category && slug) {
      const config = insightsHubCategoriesConfig.find((c) => c.key === category);
      const parent = config
        ? [{ label: config.label, to: `/research-hub/search?category=${config.key}` }]
        : [];
      return [...parent, ...leaf];
    }

    return [];
  }, [pathname, category, slug, title]);
}
